import { render } from "./NotFound.vue?vue&type=template&id=2454425c&scoped=true&ts=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=2454425c&lang=scss&scoped=true"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2454425c"]])

export default __exports__